import i18n from '@/shared/i18n';
import cloneDeep from 'lodash/cloneDeep';
import BaseModel from '@/core/components/input-widget/BaseModel';

export default class VendorChargeDataModel extends BaseModel {
  calculate_from = '';
  is_aggregate = false;
  is_taxable = false;
  is_tax_inclusive = false;
  is_pay_upfront = false;
  is_exclude = false;
  is_active = true;
  tax_rate = 0;
  tiers = [];
  lot_statuses = 'sold';
  is_grouped = true;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.calculate_from = this.calculate_from ? this.calculate_from.split(',') : [];
    this.lot_statuses = this.lot_statuses ? this.lot_statuses.split(',') : ['sold'];
    if (!this.tiers) {
      this.tiers = [];
    }
    if (!this.minimum_calculate_from) {
      this.minimum_calculate_from = 0;
    }
  }

  rules = {
    start_date: 'required',
    applies_to: 'required',
  };

  attributeLabels = {
    applies_to: i18n.t('Applies To'),
    is_aggregate: i18n.t('Is Aggregate'),
    is_taxable: i18n.t('Is Taxable'),
    is_tax_inclusive: i18n.t('Is Tax Inclusive'),
    tax_rate: i18n.t('Tax Rate'),
    // is_pay_upfront: i18n.t('Is Pay Upfront'),
    // is_exclude: i18n.t('Is Exclude'),
    is_active: i18n.t('Is Active'),
    calculate_from: i18n.t('Calculate From'),
    minimum_calculate_from: i18n.t('Minimum Calculate From'),
    comment: i18n.t('Comment'),
    lot_statuses: i18n.t('Lot Statuses'),
    is_grouped: i18n.t('Is Grouped'),
  };

  toJSON() {
    let data = cloneDeep(super.toJSON());
    data.calculate_from = data.calculate_from.join(',');
    data.lot_statuses = data.lot_statuses.join(',');
    return data;
  }
}
